import pino from 'pino'

interface LoggerInterface {
  info: (...args: any[]) => void
  error: (...args: any[]) => void
  warn: (...args: any[]) => void
  debug: (...args: any[]) => void
}

class ServerLogger implements LoggerInterface {
  private logger: pino.Logger

  constructor() {
    this.logger = pino({
      level: 'info',
    })
  }

  private log(method: 'info' | 'error' | 'warn' | 'debug', ...args: any[]) {
    // If only one argument is provided, log it directly.
    // Logger.info('Hello World')
    if (args.length === 1) {
      this.logger[method](args[0])
    } else {
      // Example: Logger.info('first message', JSON.stringify(obj));
      this.logger[method](args.splice(1), args[0])
    }
  }

  info(...args: any[]) {
    this.log('info', ...args)
  }

  error(...args: any[]) {
    this.log('error', ...args)
  }

  warn(...args: any[]) {
    this.log('warn', ...args)
  }

  debug(...args: any[]) {
    this.log('debug', ...args)
  }
}

class BrowserLogger implements LoggerInterface {
  info(...args: any[]) {
    console.info(...args)
  }

  error(...args: any[]) {
    console.error(...args)
  }

  warn(...args: any[]) {
    console.warn(...args)
  }

  debug(...args: any[]) {
    console.debug(...args)
  }
}

export const Logger: LoggerInterface =
  // @ts-ignore
  typeof window === 'undefined' ? new ServerLogger() : new BrowserLogger()

export default Logger
